import Ajv from 'ajv';

// Define the product schema with more validation and format checks
const productSchema = {
  type: "object",
  properties: {
    "@context": { type: "string" },
    "@type": { type: "string" },
    name: { type: "string" },
    description: { type: "string" },
    image: { type: "string", format: "uri" },
    brand: {
      type: "object",
      properties: {
        "@type": { type: "string" },
        name: { type: "string" },
        image: { type: "string", format: "uri" },
        url: { type: "string", format: "uri" },
      },
      required: ["@type", "name", "image", "url"],
    },
    aggregateRating: {
      type: "object",
      properties: {
        "@type": { type: "string" },
        ratingValue: { type: "number" },
        reviewCount: { type: "integer" },
      },
      required: ["@type", "ratingValue", "reviewCount"],
    },
    offers: {
      type: "object",
      properties: {
        "@type": { type: "string" },
        priceCurrency: { type: "string" },
        price: { type: "number" },
        availability: { type: "string", format: "uri" },
      },
      required: ["@type", "priceCurrency", "price", "availability"],
    },
    review: {
      type: "array",
      items: {
        type: "object",
        properties: {
          "@type": { type: "string" },
          reviewBody: { type: "string" },
          author: {
            type: "object",
            properties: {
              "@type": { type: "string" },
              name: { type: "string" },
            },
            required: ["@type", "name"],
          },
          reviewRating: {
            type: "object",
            properties: {
              "@type": { type: "string" },
              ratingValue: { type: "number" },
            },
            required: ["@type", "ratingValue"],
          },
        },
        required: ["@type", "reviewBody", "author", "reviewRating"],
      },
    },
  },
  required: ["@context", "@type", "name", "description", "image", "brand", "aggregateRating", "offers", "review"],
  additionalProperties: true,
};

// Define the FAQ schema
const faqSchema = {
  type: "object",
  properties: {
    "@context": { type: "string" },
    "@type": { type: "string" },
    question: { type: "string" },
    answer: { type: "string" },
  },
  required: ["@context", "@type", "question", "answer"],
  additionalProperties: true,
};

// Function to validate schema based on the type
export const validateSchema = (data, type) => {
  const ajv = new Ajv({ allErrors: true, verbose: true }); // Enable all errors and verbose messages
  let schemaToValidate;

  // Select schema based on type
  switch (type) {
    case "Product":
      schemaToValidate = productSchema;
      break;
    case "FAQ":
      schemaToValidate = faqSchema;
      break;
    default:
      return { valid: false, errors: ["Invalid schema type."] }; // Invalid type
  }

  // Compile and validate schema
  const validate = ajv.compile(schemaToValidate);
  const valid = validate(data);

  // If the schema is invalid, return detailed errors
  if (!valid) {
    return { valid: false, errors: formatAjvErrors(validate.errors) };
  }

  // If valid, return true
  return { valid: true };
};

// Function to format Ajv errors in a user-friendly way
const formatAjvErrors = (errors) => {
  if (!errors) return [];
  return errors.map((error) => ({
    message: `Property '${error.dataPath}' ${error.message}`,
    path: error.dataPath,
    params: error.params,
  }));
};
